import React, {useEffect, useState,useRef} from "react";
import "./Address.scss";
import {useHistory, useLocation} from "react-router";
import {CityData, getAddressFromOSM, ProvinceData, SendAddress} from "./AddressService";
//import {Map} from "./Map";
import toaster from "toasted-notes";
import {ChangeDefaultAddress} from "../../Components/OnlineAddress/OnlineAddressService";
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup,useMapEvents,useMap  } from 'react-leaflet'
import L from 'leaflet';
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useResp} from "../../hooks";
import {getMallMerchant_api, getNeshanToken_api, searchOsmAddress_api} from "../../Services/apis";
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import FooterMobile from "../DesktopComponents/FooterMobile/FooterMobile";
// import VectorTileLayer from "react-leaflet-vector-tile-layer";

let coo = [35.6892, 51.3890]

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function LocationMarker({getAdd}) {
    const [position, setPosition] = useState(null)
    const map = useMapEvents({
        click() {
            console.log("click")
            // map.locate()
        },
        moveend(e) {
            let cc = map.getCenter()
            getAdd(cc.lat,cc.lng)

        },
    })

    return position === null ? null : (
        <Marker position={position}>
            <Popup>You are here</Popup>
        </Marker>
    )
}


function SetViewOnClick({ coords }) {
        const map = useMap();
        useEffect(() => {
        if (typeof window !== 'undefined') {
            // map.setView(coords);
            map.flyTo(coords, 16)
        }
    }, [coo]);
    return null;
}

function Address({side,back}) {
    const history = useHistory();
    const location = useLocation();
    const [province,set_province] = useState([]);
    const [cities,set_cities] = useState([]);

    //form states
    const [selectedProvince,set_selectedProvince] = useState("0");
    const [selectedCity,set_selectedCity] = useState("0");
    const [address,set_address] = useState("");
    const [addressDetail,set_addressDetail] = useState("");
    const [zipCode,set_zipCode] = useState("");
    const [coordinate,set_coordinate] = useState({});
    const [isDefault,set_isDefault] = useState(false);
    const [loginState,set_loginState] = useState(false);
    const [merchantId,set_merchantId] = useState(null);






    useEffect(()=>{
    console.log("ssssssssssssssssssss")
    getMerchant()
    Province();
        // if(location && location.state && location.state.merchantId)
        //     set_merchantId(location.state.merchantId)
        setTimeout(()=>{
            window.scrollTo({left: 0, top: 0});
        },500)


    },[])

    const [neshanToken,set_neshanToken] = useState(null)
    const getMerchant = async () => {
        try {
            const res = await getMallMerchant_api()
            set_merchantId(res.data.uid)
            getNeshanToken(res.data.uid)
        } catch (e) {
            console.log(e)
        }
    }

    const getNeshanToken = async (mId) => {
        try {
            const res = await getNeshanToken_api(mId)
            set_neshanToken(res.data.map_key)
        } catch (e) {
            console.log(e)
        }
    }


    const Province = async () =>{
        const response = await ProvinceData();
        // let teh = response.data.find(p=>p.title === "تهران")
        // set_selectedProvince(teh.uid)
         set_province(response.data);
        // City(teh.uid)
    }

    const City = async (state) =>{
        const response = await CityData(state);
        // console.log(response.data)
        // let teh = response.data.find(p=>p.title === "تهران")
        // if(teh)
        //     set_selectedCity(teh.uid)

        set_cities(response.data);
    }

    const provinceChange = (e) =>{
        City(e.target.value)
        set_selectedProvince(e.target.value)
    }


    const setAddress=async ()=>{
        set_loginState(true)
        let obj = {
            address:address +" , "+addressDetail,
            postal_code:zipCode,
            is_default:isDefault,
            city:selectedCity,
            coordinate:{latitude:coordinate.lat,longitude:coordinate.lng}
        }

        console.log(obj);


        if(selectedCity.length<1 || selectedCity==="0"){
            toaster.notify(({ onClose }) => (<Error   message={"شهر را انتخاب نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }

        if(address.length<1){
            toaster.notify(({ onClose }) => (<Error   message={"آدرس را تکمیل نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }

        if(addressDetail.length<1){
            toaster.notify(({ onClose }) => (<Error   message={"جزییات آدرس را تکمیل نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }



        // if(zipCode.length!==10){
        //     toaster.notify(({ onClose }) => (<Error   message={"کدپستی را بطور صحیح وارد نمایید"}/>),{duration: 2000});
        //     set_loginState(false)
        //     return ;
        // }

        if(!coordinate.lat){
            toaster.notify(({ onClose }) => (<Error   message={"موقعیت خود را بروی نقشه تعیین نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }

        // set_loginState(false)
        try{
            const response = await SendAddress(obj);
            // console.log("Response : ",response);
            set_loginState(false)
            await ChangeDefaultAddress(response.data.uid,merchantId)

            console.log("side ",side)

            if(side){
                console.log("side in ",side)
             side(false,response.data)
            }else {
                console.log("side out ",side)
                history.goBack();
            }
            console.log("side fff ",side)
        }catch (e) {
            console.log("side error ",side)
            set_loginState(false)
        }

    }


    const [position,set_position] = useState([35.6892, 51.3890])



    const myIcon = L.icon({
        // iconUrl: 'https://www.pngall.com/wp-content/uploads/2017/05/Map-Marker-PNG-HD.png',
        iconUrl: '/other/marker_open.png',
        iconSize: [64,64],
        iconAnchor: [32, 64],
        popupAnchor: null,
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null
    });


    const { height, width,mobileWidth } = useWindowDimensions();




    const getAddress = async (lat,lng)=>{
        let osmAddress = await getAddressFromOSM(lat,lng,neshanToken)
        // let calcAddress = osmAddress.data[0].display_name;
        // calcAddress =  calcAddress.split(",")
        // calcAddress = calcAddress.slice(0, -5);
        // let reverse = calcAddress.reverse();
        // set_address(reverse.toString())
          set_address(`${osmAddress.data.formatted_address}`)


          set_position([lat,lng])
          set_coordinate({lat,lng})
    }

    const resp = useResp()

    //neshan
    const [neshanSearchWord,set_neshanSearchWord] = useState("")
    const [neshanList,set_neshanList] = useState([])
    const [neshanListShow,set_neshanListShow] = useState(false)

    const neshanSearch = async (word)=>{
        if(word.length>3){
            set_neshanListShow(true)
            try{
                const res = await searchOsmAddress_api(word,neshanToken)
                set_neshanList(res.data.items)
            }catch (e) {
                console.log(e)
            }
        }else {
            set_neshanListShow(false)
        }

    }


    const setMapToLocation = (obj)=>{
        console.log(obj)
        coo = obj
        //
        set_position(obj)
        set_neshanListShow(false)

    }


    const [map, setMap] = useState(null)
    let mapRef = useRef();

    return(
        <>
            <div>
                <DrShopHeader home={true}/>

                {/*{!resp? <div className="online-header-section" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>*/}

                {/*    {back?<i className="fa fa-arrow-left"*/}
                {/*             onClick={()=>{*/}
                {/*                 history.goBack()*/}
                {/*             }}*/}
                {/*    ></i>:null}*/}
                {/*    <span>افزودن آدرس</span>*/}
                {/*</div>:null}*/}



                <div className="online-address-container" >


                    <div className="address-body">

                        <i
                            onClick={() => history.goBack()}
                            className="fa fa-arrow-left clickable"></i>

                        <div className="address-main">








                            <div className="neshan-search-wr">

                                <div className="neshan-search">
                                    {neshanToken?<input
                                        value={neshanSearchWord}
                                        onChange={e=>{
                                            set_neshanSearchWord(e.target.value);
                                            neshanSearch(e.target.value)
                                        }}
                                        type="text" name="" id="" placeholder="آدرس خود را جستجو نمایید"/>:null}
                                    {neshanListShow?<div className="neshan-search-list">
                                        {neshanList.slice(0,10).map(n=>{
                                            return(
                                                <div className="neshan-search-item" onClick={e=>{setMapToLocation({lat:n.location.y,lng:n.location.x})}}>
                                                    <span className="neshan-search-item-neighbourhood">{n.neighbourhood}</span>
                                                    <span className="neshan-search-item-address">{n.address}</span>
                                                    <span className="neshan-search-item-title">{n.title}</span>
                                                </div>
                                            )
                                        })}



                                    </div>:null}

                                </div>

                            </div>


                            <div className="osm-sec">
                                <div className="osm-custom-flag">
                                    <img src="/other/marker_open.png" alt=""/>
                                </div>
                                <MapContainer
                                    ref={mapRef}
                                    center={position}
                                    zoom={13}>>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'
                                    />
                                    {neshanToken?<LocationMarker getAdd={getAddress} />:null}
                                    <SetViewOnClick coords={position} />
                                </MapContainer>

                            </div>


                            <div className="online-address-row-sec">
                                <div className="online-address-row" style={side?{flexDirection:'row-reverse'}:{flexDirection:'row'}}>
                                    <div className="online-address-item" >
                                        <span><span className="mandatory-badg">*</span> شهر</span>
                                        <select
                                            value={selectedCity}
                                            onChange={e=>set_selectedCity(e.target.value)}
                                            name="" id="">
                                            <option value="0">انتخاب شهر</option>
                                            {cities.map(item=>{
                                                return(
                                                    <option value={item.uid}>{item.title}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className="online-address-item">
                                        <span><span className="mandatory-badg">*</span>استان </span>
                                        <select
                                            value={selectedProvince}
                                            onChange={provinceChange}
                                            name="" id="">
                                            <option value="0">انتخاب استان</option>
                                            {province.map(item=>{
                                                return(
                                                    <option value={item.uid}>{item.title}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>

                                <div className="online-address-row">
                                    <div className="online-address-item">
                                        <span><span className="mandatory-badg">*</span> آدرس </span>
                                        <textarea
                                            value={address}
                                            onChange={e=>set_address(e.target.value)}
                                            name="" id="" cols="30" rows="3" placeholder="آدرس">
                        </textarea>
                                    </div>
                                </div>

                                <div className="online-address-row">
                                    <div className="online-address-item">
                                        <span><span className="mandatory-badg">*</span> جزییات آدرس </span>
                                        <textarea
                                            value={addressDetail}
                                            onChange={e=>set_addressDetail(e.target.value)}
                                            name="" id="" cols="30" rows="3" placeholder="جزییات آدرس مثل پلاک , واحد , طبقه">
                        </textarea>
                                    </div>
                                </div>

                                <div className="online-address-row">
                                    <div className="online-address-item">
                                        <span> کد پستی </span>
                                        <input
                                            value={zipCode}
                                            onChange={e=>set_zipCode(e.target.value)}
                                            type="text" name="" id="" placeholder="کد پستی"/>
                                    </div>
                                </div>


                            </div>





                            {/*<Map coordinate={set_coordinate}/>*/}

                            {/*<div className="online-address-row">*/}
                            {/*    <div className="online-address-item-flat">*/}
                            {/*        <input*/}
                            {/*            onClick={()=>{*/}
                            {/*                set_isDefault(!isDefault)*/}
                            {/*            }}*/}
                            {/*            type="checkbox" name="" id="" checked={isDefault}/>*/}
                            {/*        <span>آدرس اصلی</span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {!resp?<div className="online-address-row">
                                    <div className="online-address-btn clickable" onClick={setAddress}>
                                        {loginState?<i className="fa fa-spinner fa-spin"></i>: null}
                                        ثبت
                                    </div>
                                </div>:
                                <>
                                    <div className="add-address-sec">
                        <span className="add-address-btn clickable" onClick={setAddress}>
                             {loginState?<i className="fa fa-spinner fa-spin"></i>: null}
                            ثبت</span>
                                    </div>
                                    <br/><br/><br/>
                                </>
                            }




                        </div></div>

                </div>
            </div>

            {resp?
                <FooterDesktop/>
                :
                <FooterMobile/>
            }

            </>
    )
}


export {Address};

